<template>
  <div class="detail-container">
    <div class="detail-top-pic">
      <img v-if="type === 1" src="~@/assets/images/zhuyuan/zy-jy-bj.png" alt="">
      <img v-else src="~@/assets/images/zhuyuan/zy-jc-bj.png" alt="">
    </div>
    <van-cell-group inset>
      <!-- <van-cell title="开方医生">
        <template #default>
          {{ info.pacsStudyuniqueid }}
        </template>
      </van-cell>
      <van-cell title="开方科室">
        <template #default>
          {{ info.pacsStudyuniqueid }}
        </template>
      </van-cell> -->
      <van-cell title="报告时间">
        <template #default>
          {{ type === 1 ? info.studyTime : info.reportDate }}
        </template>
      </van-cell>
      <van-cell title="报告单号">
        <template #default>
          {{ type === 1 ? info.pacsStudyuniqueid : info.allBarCodes }}
        </template>
      </van-cell>
    </van-cell-group>
    <div class="list-box">
      <template v-if="type === 1">
        <div class="list-wrap">
          <div class="list-item">检查项目</div>
          <div class="list-item">检查结果</div>
          <div class="list-item">诊断意见</div>
        </div>
        <div class="list-wrap list-wrap2">
          <div class="list-item">{{ info.studyscripTion }}</div>
          <div class="list-item">{{ info.reportDescribe }}</div>
          <div class="list-item">{{ info.reportDiagnose }}</div>
        </div>
      </template>
      <template v-else>
        <div class="list-wrap">
          <div class="list-item list-flex2">检验项目</div>
          <div class="list-item list-flex1">单位</div>
          <div class="list-item list-flex2">检查结果</div>
          <div class="list-item list-flex1">标志</div>
          <div class="list-item list-flex2">参考值</div>
        </div>
        <div v-for="(item, index) in list" :key="index" class="list-wrap list-wrap2">
          <div class="list-item list-flex2">{{ `${item.itemName}(${item.itemCode})` }}</div>
          <div class="list-item list-flex1">{{ item.unit }}</div>
          <div class="list-item list-flex2">{{ item.currentResult }}</div>
          <div class="list-item list-flex1">{{ item.flag }}</div>
          <div class="list-item list-flex2">{{ item.ranges }}</div>
        </div>
      </template>
    </div>
    <div v-if="type === 1" class="download-btn">
      <van-button type="info" block @click="downloadPdf">下载报告</van-button>
    </div>
    <van-popup
      v-model="show"
      closeable
      position="bottom"
      :style="{ height: '85%' }"
    >
      <div class="pdf-box">
        <pdf v-for="i in numPages" :key="i" ref="pdfTest" :src="src" :page="i" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import baseInfo from '@/utils/config'
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
export default {
  name: 'ZhuYuanBaoGaoXiangQing',
  components: {
    pdf
  },
  data() {
    return {
      type: '',
      info: {},
      list: [],
      numPages: '',
      src: '',
      pdfBase64: '',
      show: false
    }
  },
  created() {
    const type = this.$route.query.type * 1
    this.type = type
    if (type === 1) {
      const id = this.$route.query.id
      const info = JSON.parse(localStorage.zyJcBaoGao || '{}')
      if (id === info.pacsStudyuniqueid) {
        this.id = id
        this.info = info
      }
      if (info.sleepReportBASE64) {
        this.pdfBase64 = info.sleepReportBASE64.split('=')[1]
      }
    } else {
      const { patientName, reportNo } = this.$route.query
      this.patientName = patientName
      this.reportNo = reportNo
      this.getReportDetail()
    }
  },
  mounted() {
  },
  methods: {
    getReportDetail() {
      const obj = {
        patientName: this.patientName,
        reportNo: this.reportNo
      }
      this.$Apis.getZYPatientZyReportDetail(obj).then(res => {
        if (res.code === 200 && res.data.tables.length > 0) {
          this.list = res.data.tables
          this.info = res.data.tables[0]
        } else {
          this.$toast(res.message || '暂无数据')
        }
      })
    },
    downloadReport() {
      const pdfBase64 = this.info.sleepReportBASE64
      if (!pdfBase64) {
        this.$toast('暂无数据！')
        return
      }
      this.show = true
      const datas = 'data:application/pdf;base64,' + pdfBase64
      this.src = pdf.createLoadingTask({
        url: datas,
        CMapReaderFactory
      })
      this.src.promise.then(pdf => {
        this.numPages = pdf.numPages
      })
    },
    downloadPdf() {
      if (!this.pdfBase64) {
        this.$toast('暂无数据！')
        return
      }
      const url = baseInfo.BASE_URL_PDF + this.pdfBase64
      console.log('url', url)
      try {
        const link = document.createElement('a')
        link.href = url
        link.download = `检查报告_${this.info.pacsStudyuniqueid || Date.now()}.pdf`
        link.target = '_blank'

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$toast.success('开始下载PDF文件')
      } catch (error) {
        console.error('直接下载失败:', error)
        this.$toast.fail('下载失败，请重试')

        // 最后的回退方案：在新窗口打开
        window.open(url)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.detail-container{
  margin-top: .1rem;
  height: calc(100vh - 1rem);
  padding-bottom: .1rem;
  border-radius: .1rem;
  overflow-y: auto;
  .detail-top-pic{
    margin: .1rem .15rem;
    img{
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .list-box{
    margin: .1rem .05rem 0;
    border-radius: .1rem;
    background: #FFFFFF;
    padding: .1rem 0.05rem;
  }
  .list-wrap{
    display: flex;
    border-top: 1px solid #E8EAED;
    border-bottom: 1px solid #E8EAED;
    .list-item{
      color: #2B8CFF;
      background: #F8F8F8;
      flex: 1;
      word-break: break-all;
      padding: .1rem .05rem;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1.5;
      border-left: 1px solid #E8EAED;
    }
    :last-child{
      border-right: 1px solid #E8EAED;
    }
    .list-flex1{
      flex: 1;
    }
    .list-flex2{
      flex: 2;
    }
    .list-flex3{
      flex: 3;
    }
  }
  .list-wrap2{
    border-top: none;
    .list-item{
      color: #555;
      background: #fff;
    }
  }
}
.download-btn {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 500px;
  margin: 0.2rem 0 0;
  text-align: center;
  padding: 0.15rem 1rem 0.35rem;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 0.1rem 0.1rem 0 0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}
.pdf-box {
  padding: .3rem .1rem .1rem;
}
</style>
